// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__2is2i","paper":"style_paper__2Ah7e","content":"style_content__4o01a","title":"style_title__2_KAP","image":"style_image__1p27X"};